export default __webpack_public_path__ + "static/media/mobile_79.49ebb149.jpg";